import React, { useState, useEffect, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Import Gallery Images (Double-check these paths!!)
import ayurved1 from '../assets/Gallery/7.jpeg';  // Example paths - VERIFY!
import ayurved2 from '../assets/Gallery/10.jpeg';
import ayurved3 from '../assets/Gallery/DSC_0683.JPG';
import ayurved4 from '../assets/Gallery/Ayurvedic-Spa-and-Wellness-Gallery4-1300x700-1-ezgif.com-webp-to-jpg-converter.jpg';
import ayurved5 from '../assets/Gallery/DSC_0391.JPG';
import ayurved6 from '../assets/Gallery/DSC_0345.JPG';
import ayurved7 from '../assets/Gallery/DSC_0354.JPG';
import ayurved8 from '../assets/Gallery/DSC_0364.JPG';
import ayurved9 from '../assets/Gallery/DSC_0367.JPG';
import ayurved10 from '../assets/Gallery/17.jpeg';
import ayurved11 from '../assets/Gallery/14.jpeg';
import ayurved12 from '../assets/Gallery/15.jpeg';
import ayurved13 from '../assets/Gallery/21.jpeg';

import villa1 from '../assets/Gallery/DSC_0502.JPG';
import villa2 from '../assets/Gallery/DSC_0551.JPG';
import villa3 from '../assets/Gallery/DSC_0576.JPG';
import villa4 from '../assets/Gallery/DSC_0525.JPG';
import villa5 from '../assets/Gallery/DSC_0522.JPG';
import villa6 from '../assets/Gallery/DSC_0591.JPG';
import villa7 from '../assets/Gallery/DSC_0561.JPG';
import villa8 from '../assets/Gallery/DSC_0534.JPG';
import villa9 from '../assets/Gallery/DSC_0578.JPG';
import villa10 from '../assets/Gallery/DSC_0570.JPG';
import villa11 from '../assets/Gallery/WhatsApp Image 2025-02-16 at 20.19.55.jpeg';


import tour1 from '../assets/Gallery/IMG_9560.jpg';
import tour2 from '../assets/Gallery/IMG_0077.jpg';
import tour3 from '../assets/Gallery/IMG_9325.jpg';
import tour4 from '../assets/Gallery/IMG_9638.jpg';
import tour5 from '../assets/Gallery/WhatsApp Image 2025-02-08 at 21.18.17.jpeg';
import tour6 from '../assets/Gallery/WhatsApp Image 2025-02-08 at 21.05.26.jpeg';
import tour7 from '../assets/Gallery/01.jpeg';
import tour8 from '../assets/Gallery/02.jpeg';
import tour9 from '../assets/Gallery/03.jpeg';
import tour10 from '../assets/Gallery/04.jpeg';
import tour11 from '../assets/Gallery/05.jpeg';
import tour12 from '../assets/Gallery/06.jpeg';
import tour13 from '../assets/Gallery/07.jpeg';
import tour14 from '../assets/Gallery/08.jpeg';
import tour15 from '../assets/Gallery/010.jpeg';
import tour16 from '../assets/Gallery/011.jpeg';
import tour17 from '../assets/Gallery/1.jpeg';
import tour18 from '../assets/Gallery/2.jpeg';
import tour19 from '../assets/Gallery/3.jpeg';
import tour20 from '../assets/Gallery/4.jpeg';
import tour21 from '../assets/Gallery/5.jpeg';
import tour22 from '../assets/Gallery/6.jpeg';
import tour23 from '../assets/Gallery/8.jpeg';
import tour24 from '../assets/Gallery/9.jpeg';


const Gallery = () => {
    const [category, setCategory] = useState('All');
    const [displayedImages, setDisplayedImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const images = useMemo(() => ({
        All: [ayurved1, ayurved2, ayurved3, ayurved4, ayurved5, ayurved6, ayurved7, villa1, villa2, villa3, villa4, villa5, villa6, villa7, ayurved10, ayurved11, ayurved12, ayurved13, tour1, tour2, tour3, tour4, villa8, villa9, villa10, villa11, tour5, tour6, tour7, tour8, tour9, tour10, tour11, tour12, tour13, tour14, tour15, tour16, ayurved8, ayurved9, tour17, tour18, tour19, tour20, tour21, tour22, tour23, tour24],
        Ayurved: [ayurved1, ayurved2, ayurved3, ayurved4, ayurved5, ayurved6, ayurved7, ayurved8, ayurved9, ayurved10, ayurved11, ayurved12, ayurved13],
        Villa: [villa1, villa2, villa3, villa4, villa5, villa6, villa7, villa8, villa9, villa10, villa11],
        Tours: [tour1, tour2, tour3, tour4, tour5, tour6, tour7, tour8, tour9, tour10, tour11, tour12, tour13, tour14, tour15, tour16, tour17, tour18, tour19, tour20, tour21, tour22, tour23, tour24],
    }), []); // Empty dependency array - images is stable

    useEffect(() => {
        setDisplayedImages(images[category] || []); // Handle potential undefined category
    }, [category, images]); // category MUST be here, images SHOULD be here

    const handleImageClick = (img) => {
        setIsLoading(true);
        setSelectedImage(img);
        setShowModal(true);

        // Simulate loading of large image
        const image = new Image();
        image.src = img;
        image.onload = () => {
            setIsLoading(false);
        };
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage(null);
        setIsLoading(false);
    };

    return (
        <section className="container my-5">
            <h2 className="text-center fw-bold text-dark mb-4 display-4">Our Gallery</h2>

            <div className="d-flex justify-content-center mb-4 flex-wrap">
                {['All', 'Ayurved', 'Villa', 'Tours'].map((btn) => (
                    <button
                        key={btn}
                        className={`btn mx-2 my-1 ${category === btn ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => setCategory(btn)}
                    >
                        {btn}
                    </button>
                ))}
            </div>

            <div className="row">
                {displayedImages.map((img, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                        <div className="card border-0 shadow-lg overflow-hidden rounded-4">
                            <img
                                src={img}
                                alt={`Gallery ${index + 1}`}
                                className="img-fluid rounded"
                                style={{ objectFit: 'cover', height: '250px', width: '100%', cursor: 'pointer' }}
                                onClick={() => handleImageClick(img)}
                                loading="lazy"
                            />
                        </div>
                    </div>
                ))}
            </div>

            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Body className="p-0 position-relative">
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <img
                            src={selectedImage}
                            alt="Enlarged Gallery"
                            className="img-fluid rounded"
                            style={{ width: '100%' }}
                        />
                    )}
                    <Button
                        variant="secondary"
                        onClick={handleCloseModal}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            zIndex: 1000,
                            borderRadius: '50%',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        &times;
                    </Button>
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default Gallery;